import PubSub from "underpub-js";
import gsap from "gsap";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
Swiper.use([Navigation]);
import {
	nodeName
} from "jquery";

var ListingUnitTypes = function (options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingUnitTypes',
	};

	$.extend(true, this.options, options);

};

ListingUnitTypes.prototype.init = function () {

	var self = this;

	self.centerSlides = self.options.$el.attr("data-center-slides") == "true";
	self.numberOfSlides = parseInt(self.options.$el.attr("data-number-of-slides"));
	self.$slides = self.options.$el.find(`.${self.options.baseClass}__items`);
	self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
	self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

	self.$filtersDropdown = self.options.$el.find(`.${self.options.baseClass}__filters__dropdown`);
	self.$items = self.options.$el.find(`.${self.options.baseClass}__item`)

	self.$filtersDropdown.on("change", () => self.updateFilters());
	self.initCarousel();
};

ListingUnitTypes.prototype.updateFilters = function () {
	const self = this;

	const selectedFilterValue = self.$filtersDropdown.val();

	console.log(selectedFilterValue);

	if (selectedFilterValue.length) {
		self.$activeItems = self.$items.filter((i, el) => {
			return $(el).find(`[data-unit-category="${selectedFilterValue}"]`).length;
		});
	} else {
		self.$activeItems = self.$items;
	}

	gsap.timeline({
		defaults: {
			ease: "expo.out",
			duration: 1,
		}
	})
		.to(self.$items, {
			duration: .4,
			opacity: 0,
		})
		.set(self.$items.not(self.$activeItems), {
			display: "none",
		})
		.set(self.$activeItems, {
			display: "block",
		})
		.to(self.$activeItems, {
			opacity: 1
		})
};

ListingUnitTypes.prototype.initCarousel = function () {
	var self = this;

	let swiperOptions = {
		loop: true,
		//loopAdditionalSlides: 5,
		initialSlide: self.numberOfSlides,
		centeredSlides: false,

		// Responsive breakpoints
		breakpoints: {
			1024: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 2,
			},
			0: {
				slidesPerView: 1, // Default
			},
		},

		// arrows
		navigation: {
			nextEl: self.$arrowNext[0],
			prevEl: self.$arrowPrev[0],
		},

		spaceBetween: 36,
	};

	self.swiper = new Swiper(self.$slides[0], swiperOptions);
};

export default ListingUnitTypes;
